<template>
  <div class="dangJianShe">
    <div class="form-content">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" class="ruleFormYan">
        <el-row :gutter="20">
          <el-col :span="12" v-for="(item,index) in ruleForm.zhengfu_rongyu" :key="item.date">
            <div class="flex justify-start align-center">
              <div class="flex-sub flex-sub-w0">
                <el-form-item label="是否获得政府相关部门荣誉"
                              :ref="'zhengfu_rongyu.' + index + '.value'"
                              :prop="'zhengfu_rongyu.' + index + '.value'"
                              :rules="{
                                required: false, message: '请选择', trigger: 'change'
                              }">
                  <div class="flex justify-start align-center">
                    <el-select v-model="item.value" @change="zhengChange" placeholder="请选择" class="inp">
                      <el-option
                        v-for="item in rongyuTypeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    <div class="tips zhengm">
                      <i class="iconfont icon-xinxitishi"></i>注：同一类级别奖励下获得多个不同奖项，请打包上传附件
                    </div>
                  </div>
                </el-form-item>
              </div>
              <el-form-item label="" class="errorTips"
                            v-if="item.value && item.value != 4"
                            :ref="'zhengfu_rongyu.' + index + '.file'"
                            :prop="'zhengfu_rongyu.' + index + '.file'"
                            :rules="{
                                required: false, message: '请上传', trigger: 'change'
                              }">
                <div class="flex justify-start align-center">
                  <a :href="item.file" v-if="item.file" target="_blank"  class="look">查看附件</a>
                  <upload-file
                    class="upZuj"
                    name="zhengfu_rongyu"
                    :index="index"
                    @uploadFile="uploadFile"
                  >
                    <div class="btnUp" slot="upload">
                      <i class="iconfont icon-iconfontzhizuobiaozhun0263"></i> 上传附件
                    </div>
                  </upload-file>
                </div>
              </el-form-item>
              <div v-if="item.value != 4">
                <img src="@/assets/images/tianjiaicon.png" v-if="index == 0" class="add" @click="addZheng()" alt="">
                <img src="@/assets/images/jianhaoicon.png" v-else class="add" @click="delZheng(index)" alt="">
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <el-form-item label="参与行业互助情况" >
              <div class="flex justify-start align-center">
                <el-select v-model="ruleForm.huzhu" placeholder="请选择" class="inp">
                  <el-option
                    v-for="item in huzhuTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <div class="tips">
                  <i class="iconfont icon-xinxitishi"></i>注：整体承接指承接所有学员，部分承接指只承接部分学员
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="ruleForm.huzhu == 2">
            <el-form-item label="承接率" >
              <div class="flex justify-start align-center">
                <el-input v-model="ruleForm.chengjie_lv" class="inp">
                  <template slot="append">
                    <el-button>%</el-button>
                  </template>
                </el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12" >
            <el-form-item label="参与培训、活动等出勤情况参与率" >
              <div class="flex justify-start align-center">
                <el-input v-model="ruleForm.huodong_lv" class="inp">
                  <template slot="append">
                    <el-button>%</el-button>
                  </template>
                </el-input>
                <div class="tips">
                  <i class="iconfont icon-xinxitishi"></i>注：在一个自然年度内，参与行业主管部门组织的培训及活动次数，按参加时间实时填写
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="btn-box ">
        <div class="btn" @click="submitForm('ruleForm',1)">临时保存</div>
        <div class="btn margin-left-xs" @click="submitForm('ruleForm',2)">提交</div>
      </div>
    </div>
  </div>
</template>
<script>
import {scrollIntoView} from "@/utils/utils";
import {huzhuTypeOptions, isYes, rongyuTypeOptions} from "@/utils/const";
import UploadFile from "@/components/UploadFile";
import {
  get_yunying,
  save_cujin
} from "@/api/index";
export default {
  name: "anquan",
  data() {
    return {
      isYes: isYes,
      rongyuTypeOptions: rongyuTypeOptions,
      huzhuTypeOptions: huzhuTypeOptions,
      ruleForm: {
        huzhu: '', // 参与行业互助情况
        chengjie_lv: '', // 承接率
        huodong_lv: '', // 活动等出勤情况参与率
        zhengfu_rongyu:[{   // zhengfu_rongyu
          value: '',
          file: '',
          id: Date.now()
        }]
      },
      rules: {
        huodong_lv: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        chengjie_lv: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        huzhu: [
          {required: false, message: '请选择', trigger: 'change'}
        ],

      }
    }
  },
  components: {UploadFile},
  created() {
    this.init()
  },
  methods: {
    async init(){
      let _data = await get_yunying(7);
      if(_data.status == 200){
        this.ruleForm = {
          huzhu: _data.data.huzhu, // 参与行业互助情况
          chengjie_lv: _data.data.chengjie_lv, // 承接率
          huodong_lv: _data.data.huodong_lv, // 活动等出勤情况参与率
          zhengfu_rongyu:_data.data.zhengfu_rongyu ? _data.data.zhengfu_rongyu : [{
            value: '',
            file: '',
            id: Date.now()
          }]
        }
      }
    },
    submitForm(formName,zancun) {
      if(zancun == 1){
        this.submitInfo(zancun)
      }else {
        this.$refs[formName].validate((valid, validates) => {
          if (valid) {
            this.submitInfo(zancun)
          } else {
            scrollIntoView(this, validates)
          }
        });
      }

    },

    async submitInfo(zancun) {
      let _data = await save_cujin(
        zancun,
        this.ruleForm.huzhu,
        this.ruleForm.chengjie_lv,
        this.ruleForm.huodong_lv,
        JSON.stringify(this.ruleForm.zhengfu_rongyu)
      );
      if (_data.status == 200) {
        this.$message.success(_data.msg);
      } else {
        this.$message.error(_data.msg);
      }
    },

    uploadFile(data) {
      this.ruleForm[data.name][data.index].file = data.file.url
    },

    zhengChange(e){
      if(e == 4) {
        this.ruleForm.zhengfu_rongyu = [{
          value: 4,
          file: '',
          date: Date.now()
        }];
      }
    },
    addZheng() {
      this.ruleForm.zhengfu_rongyu.push({
        value: '',
        file: '',
        date: Date.now()
      });
    },
    delZheng(index) {
      this.ruleForm.zhengfu_rongyu.splice(index, 1);
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.dangJianShe {
  .form-content {
    width: 100%;

    .width {
      width: 400px;
    }

    .btn-box {
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 30px 0;

      .btn {
        width: 180px;
        height: 40px;
        background-image: linear-gradient(0deg,
          #2791ff 0%,
          #81b6ff 100%);
        border-radius: 20px;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        letter-spacing: 1px;
        color: #ffffff;
        cursor: pointer;
      }
    }

    .add {
      width: 36px;
      margin-left: 10px;
      margin-top: 10px;
      cursor: pointer;
    }

    .inp {
      flex: 1;
    }

    .tips {
      width: max-content;
      padding: 0 10px;
      height: 36px;
      background-color: #fef0ef;
      border-radius: 4px;
      margin-left: 10px;
      font-size: 14px;
      color: #f34336;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      line-height: 16px;

      i {
        font-size: 20px;
        color: #f34336;
        margin-right: 4px;
      }
      &.short {
        width: 120px;
      }
      &.zhengm {
        width: 250px;
      }
      &.width {
        width: 350px;
      }
    }

    .look {
      width: max-content;
      padding: 0 10px;
      height: 36px;
      border: 1px solid #2791ff;
      color: #2791ff;
      line-height: 34px;
      text-align: center;
      font-size: 14px;
      margin-left: 10px;
      border-radius: 4px;
      margin-top: 15px;
    }

    .btnUp {
      width: max-content;
      padding: 0 10px;
      height: 36px;
      margin-left: 10px;
      background-image: linear-gradient(90deg,
        #2791ff 0%,
        #81b6ff 100%);
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #ffffff;

      i {
        font-size: 20px;
        color: #ffffff;
        margin-right: 5px;
        font-weight: 100;
      }
    }
  }

}
</style>


